// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__+0CFq","total":"Cart_total__Kk+DV","actions":"Cart_actions__ZxicR","button--alt":"Cart_button--alt__aO2oI","button":"Cart_button__P3HxL"};